import React, { useState } from 'react';
import { Button, Tooltip } from 'kenshin';
import {
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  LinkOutlined,
  ExportOutlined,
} from '@ant-design/icons';
import RelateTaskModal from '../RelateTaskModal';
import './index.less';
import { exporttaskplandata } from '@/_serveice/task';
import { downloadXlsx } from '@/_util';

const OperationBar = ({
  hotTableRef,
  onBatchAdd,
  onLocalAdd,
  MapData,
  taskExcelSheetId,
  tabs,
  selectedTaskIds,
}) => {
  const [relateModalVisible, setRelateModalVisible] = useState(false);

  const setAddDefaultData = () => {
    if (hotTableRef.current?.hotInstance) {
      const instance = hotTableRef.current.hotInstance;
      // 设置新增行的优先级为"中"
      instance.setDataAtRowProp(0, 'taskPriority', '2');
    }
  };

  const handleUndo = () => {
    if (hotTableRef.current?.hotInstance) {
      hotTableRef.current.hotInstance.undo();
    }
  };

  const handleRedo = () => {
    if (hotTableRef.current?.hotInstance) {
      hotTableRef.current.hotInstance.redo();
    }
  };

  const handleAddRow = () => {
    // if (hotTableRef.current?.hotInstance) {
    //   const instance = hotTableRef.current.hotInstance;
    //   MapData.current.unshift({});
    //   instance.alter('insert_row_above');
    //   // setAddDefaultData();
    // }
    if (onLocalAdd) {
      onLocalAdd([{}]);
    } else if (onBatchAdd) {
      onBatchAdd([{}]);
    }
  };

  return (
    <div className="operation-bar">
      {/* <Tooltip title="撤销">
        <div onClick={handleUndo}>
          <LeftOutlined />
        </div>
      </Tooltip>
      <Tooltip title="恢复">
        <div onClick={handleRedo}>
          <RightOutlined />
        </div>
      </Tooltip> */}
      <Tooltip title="增加行">
        <div onClick={handleAddRow} className="add-row">
          <PlusOutlined />
          添加一行
        </div>
      </Tooltip>
      {/* <Tooltip title="关联旧任务">
        <div onClick={() => setRelateModalVisible(true)} className="add-row">
          <LinkOutlined />
          关联旧任务
        </div>
      </Tooltip> */}
      <Tooltip title="导出Excel">
        <div
          onClick={() => {
            if (taskExcelSheetId) {
              const currentSheet = tabs.find(
                (item) => item.id === taskExcelSheetId,
              );
              let url = `${baseURL}${exporttaskplandata}?taskExcelSheetId=${taskExcelSheetId}`;
              if (selectedTaskIds && selectedTaskIds.length > 0) {
                url += `&taskIds=${selectedTaskIds.join(',')}`;
              }
              downloadXlsx(url, currentSheet.name);
            }
          }}
          className="add-row"
        >
          <ExportOutlined />
          导出Excel
        </div>
      </Tooltip>
      <RelateTaskModal
        visible={relateModalVisible}
        onCancel={() => setRelateModalVisible(false)}
        onOk={(selectedRows) => {
          console.log('选中的任务:', selectedRows);
          // let rows = selectedRows.map(item => {
          //   return {
          //     ...item,
          //     addTaskTeamMemberList:item.dbTaskTeamMemberList.map(it => it.taskTeamMemberId).join(','),
          //   }
          // })
          onBatchAdd?.(selectedRows);
          setRelateModalVisible(false);
        }}
      />
    </div>
  );
};

export default OperationBar;
